var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tooltip left"},[_c('span',{staticClass:"tiptext"},[_vm._v(_vm._s(_vm.status)+" - "+_vm._s(_vm.building)+" "+_vm._s(_vm.ehs_name ? '- '+_vm.ehs_name:''))]),_c('span',{staticClass:"material-icons sm",style:({color:_vm.color})},[_vm._v(_vm._s(_vm.icon))])])
}
var staticRenderFns = []

export { render, staticRenderFns }